let _ = t => t,
  _t;
import { AsyncUIAvatar } from '../../../code-splitting/public';
import StatusIndicator from './StatusIndicator';
import { Box } from 'foundations-components/transitional/components/Box';
import styledWithTheme from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ContactAvatarWrapper = styledWithTheme(Box)(_t || (_t = _`
  position: relative;
  display: table;
`));
const ContactAvatar = ({
  isKnownContact,
  email,
  contactDetail,
  vid,
  threadId
}) => {
  return /*#__PURE__*/_jsxs(ContactAvatarWrapper, {
    children: [/*#__PURE__*/_jsx(AsyncUIAvatar, {
      size: "sm",
      type: "contact",
      email: isKnownContact ? email : undefined,
      displayName: isKnownContact ? contactDetail : undefined,
      vid: isKnownContact ? vid || undefined : undefined,
      showTooltip: true,
      childMarginInlineStart: "300",
      childTruncateLength: 200
    }), threadId && /*#__PURE__*/_jsx(StatusIndicator, {
      threadId: threadId
    })]
  });
};
ContactAvatar.displayName = 'ContactAvatar';
export default ContactAvatar;